{
    "tasks__search_placeholder": "Rechercher dans les tâches",
    "tasks_overview_table__header__title": "Tâche",
    "tasks_overview_table__header__due_date": "Date limite",
    "tasks_overview_table__header__completed_at": "Terminée le",
    "tasks_overview_table__header__related_to": "Lié à",
    "tasks_overview_table__header__assigned_to_user": "Responsable",
    "tasks_overview_table__header__assigned_by_user": "Créé par",
    "tasks_overview_table__attachments_count_aria_one": "Afficher {{count}} pièce jointe",
    "tasks_overview_table__attachments_count_aria_many": "Afficher {{count}} pièces jointes",
    "tasks_overview_table__attachments_count_aria_other": "Afficher {{count}} pièces jointes",
    "filter_menu_title__customers": "Clients",
    "filter_menu_title__orders": "Commandes",
    "filter_menu_title__quotes": "Devis",
    "filter_menu_title__assigned_tos": "Responsable",
    "filter_menu_title__assigned_bys": "Créé par",
    "tasks__group_today": "Aujourd'hui",
    "tasks__group_upcoming": "À venir",
    "tasks__group_completed": "Terminées",
    "tasks__quick_filters__to_me": "Qui me sont assignées",
    "tasks__quick_filters__by_me": "Que j'ai créées",
    "tasks__empty_state__body": "Aucune tâche ici. Utilisez les tâches pour déléguer du travail à vos collègues ou pour vous fixer un rappel.",
    "tasks__empty_state__create_task": "Créer une tâche",
    "task_overview_table__options_aria": "Options de la tâche",
    "task_overview_table__options__edit_task": "Modifier la tâche",
    "task_overview_table__options__delete_task": "Supprimer la tâche",
    "tasks__delete_confirmation__title": "Supprimer la tâche",
    "tasks__delete_confirmation__body": "La tâche sera définitivement supprimée. Cette action est irréversible.",
    "tasks__assigned_to_placeholder": "Sélectionner un utilisateur",
    "tasks__assigned_to_placeholder_multiple": "Sélectionner des utilisateurs (plusieurs possibles)",
    "tasks_open_tasks": "Tâches ouvertes",
    "overdue": "En retard",
    "due_today": "Échéance aujourd'hui",
    "details__title": "Tâche",
    "tasks__form_create_title": "Créer une tâche",
    "tasks__form_edit_title": "Tâche",
    "tasks__form_create_submit_zero": "Créer une tâche",
    "tasks__form_create_submit_one": "Créer une tâche",
    "tasks__form_create_submit_many": "Créer {{count}} tâches",
    "tasks__form_create_submit_other": "Créer {{count}} tâches",
    "tasks__description_placeholder": "Décrire la tâche",
    "tasks__toast__created_one": "Tâche créée avec succès",
    "tasks__toast__created_many": "{{count}} tâches créées avec succès",
    "tasks__toast__created_other": "{{count}} tâches créées avec succès",
    "tasks__toast__edited_success_title": "Tâche modifiée avec succès",
    "tasks__toast__success_body": "Vous pouvez la consulter <linkTag>ici</linkTag>",
    "tasks__toast__deleted_success_title": "Tâche supprimée avec succès",
    "tasks__entity_search__placeholder": "Rechercher un client, une commande ou un devis",
    "form__complete_task": "Marquer comme terminée",
    "form__open_task": "Rouvrir la tâche",
    "tasks__form__created_by_label": "Créé par",
    "tasks__form__download_file": "Télécharger",
    "tasks__form__download_error": "Échec du téléchargement du fichier",
    "tasks__form__edit_file": "Modifier",
    "tasks__form__delete_attachment_confirmation__title": "Supprimer la pièce jointe",
    "tasks__form__delete_attachment_confirmation__body": "La pièce jointe sera supprimée. Cette action est irréversible.",
    "task_not_found": "Tâche introuvable",
    "status_OPEN": "Ouverte",
    "status_COMPLETED": "Terminée",
    "comments__section_title": "Activité",
    "comments__add_placeholder": "Ajouter un commentaire...",
    "comments__save": "Enregistrer",
    "comments__edit": "Modifier",
    "comments__delete": "Supprimer",
    "comments__edited": "(modifié)",
    "comments__delete_confirmation__title": "Supprimer le commentaire",
    "comments__delete_confirmation__body": "Le commentaire sera définitivement supprimé. Cette action est irréversible.",
    "comments__toast__deleted_success_title": "Commentaire supprimé avec succès",
    "comments__toast__updated_success_title": "Commentaire mis à jour avec succès",
    "table_header__task": "Tâche",
    "task_column__create_task_tooltip": "Créer une tâche",
    "task_column__tasks_count_one": "{{count}} tâche",
    "task_column__tasks_count_many": "{{count}} tâches",
    "task_column__tasks_count_other": "{{count}} tâches"
}
